module.exports = __webpack_public_path__ + "36aee7df955ec96a38f0562fda351876.MP3";